__turbopack_context__.v({
  "active": "SidebarMenu-module__sgv3nW__active",
  "closed": "SidebarMenu-module__sgv3nW__closed",
  "homepageMenuItem": "SidebarMenu-module__sgv3nW__homepageMenuItem",
  "iconWrapper": "SidebarMenu-module__sgv3nW__iconWrapper",
  "open": "SidebarMenu-module__sgv3nW__open",
  "sidebarMenuItem": "SidebarMenu-module__sgv3nW__sidebarMenuItem",
  "styledLink": "SidebarMenu-module__sgv3nW__styledLink",
  "title": "SidebarMenu-module__sgv3nW__title",
});
